// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PreloaderWrapper__Wrapper_3XWaE","isLoading":"PreloaderWrapper__isLoading_huaur"};